module.exports = __webpack_public_path__ + "img/my-service.b33d988b.svg";